<template>
  <div class="m-4 md:mx-8 md:mt-16">
    <div class="flex flex-col md:flex-row md:items-center justify-between mb-4 space-y-2 md:space-y-0">
      <span class="font-semibold text-primario text-lg tracking-wide">{{ $t("lang.msg.users") }}</span>
      <div class="flex space-x-2 w-full md:max-w-lg">
        <ButtonAction @action="toggleActive" color="gray" large>
          {{ showActive ? $t('lang.msg.viewDisactives') : $t('lang.msg.viewActives') }}
        </ButtonAction>
        <ButtonRedirect route="adminSignup" color="gray">
          {{ $t("lang.msg.add") }}
        </ButtonRedirect>
      </div>
    </div>
    <datatable
      :data="data"
      :headers="headers"
      @on-row-click="openEditModal"
    />
    <TheModal
      :open="isModalOpen"
      @close="isModalOpen = false"
      :title="newItem.idUser == undefined ? $t('lang.msg.createRecord') : $t('lang.msg.updateRecord')"
    >
      <template #body>
        <form class="pt-3 space-y-4">
          <InputWrapper :label="$t('lang.fields.email')" content="input" block>
            <InputText v-model="newItem.userEmail" :name="$t('lang.fields.email')" />
          </InputWrapper>
          <InputWrapper
            v-if="hasRoles(['ADMIN', 'DIRECCIÓN'])"
            :label="$t('lang.fields.password')"
            content="input"
            block
          >
            <InputText v-model="newItem.userPassword" name="Idioma" />
          </InputWrapper>
          <InputWrapper label="Idioma" content="input" block>
            <InputText v-model="newItem.userLanguage" name="Idioma" />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.mainRole')" content="input" block>
            <Select
              id="idRol"
              :data="roles"
              track-by="rolName"
              v-model.number="newItem.mainRole"
              @change="selectMainRole"
            />
          </InputWrapper>
          <InputWrapper :label="$t('lang.msg.roles')" content="input" block>
            <multiselect
              v-model="newItem.roles"
              :options="roles"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="true"
              :preserve-search="true"
              :taggable="true"
              placeholder="Escriba para buscar roles"
              label="rolName"
              track-by="idRol"
              select-label="Pulse enter para seleccionar"
              deselect-label="Pulse enter para eliminar"
              @select="storeRole"
              @remove="removeRole"
            >
              <template slot="noOptions">
                La lista de roles está vacia.
              </template>
            </multiselect>
          </InputWrapper>
          <AdminToggleButton v-model="newItem.active" />

          <InputWrapper :label="$t('lang.msg.profilePicture')" content="input" block>
            <ButtonAction large color="blue" @action="$refs.file.click()">
              {{ $t("lang.msg.attachFile") }}
            </ButtonAction>
          </InputWrapper>
          <input
            type="file"
            ref="file"
            v-show="false"
            @change="handleFileChange"
          >
        </form>
      </template>
      <template #action>
        <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
          <button
            type="button"
            class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 hover:bg-green-700 text-base font-medium text-white shadow-sm focus:outline-none focus:border-blue-300 focus:shadow-outline transition ease-in-out duration-150"
            @click="addOrEditItem(`api/Users/Update`)"
            @keyup.enter="addOrEditItem(`api/Users/Update`)"
          >{{ $t('lang.msg.update') }}</button>
        </span>
      </template>
    </TheModal>
  </div>
</template>

<script>
import AdminMixin from "@/components/mixins/AdminMixin";
import TheModal from "@/components/shared/TheModal";
import DataTable from "@/components/shared/DataTable";
import Multiselect from "vue-multiselect";

export default {
  name: "Users",
  mixins: [AdminMixin],
  components: {
    datatable: DataTable,
    TheModal,
    Multiselect
  },
  data() {
    return {
      data: [],
      headers: {
        idUser: "#",
        userEmail: "Email"
      },
      file: "",
      roles: [],
      isModalOpen: false
    };
  },
  beforeMount() {
    // Show only passwords to those roles
    if (this.hasRoles(["ADMIN", "DIRECCIÓN"])) {
      this.$set(this.headers, 'userPassword', 'Contraseña');
    }

    // Add the remaining fields.
    this.$set(this.headers, 'userLanguage', 'Idioma');
    this.$set(this.headers, 'active', {
      type: Boolean,
      name: "Activo"
    });
  },
  created() {
    this.fetchData(`api/Users/GetUsers`);
    this.fetchRoles();
  },
  methods: {
    fetchRoles() {
      this.$axios.get(`api/Rols/GetRol`).then((response) => {
        this.roles = response.data;
      });
    },
    fetchUserRoles(id) {
      this.$axios.post(`api/Users/GetRol`, {
        idUser: id
      }).then((response) => {
        let data = response.data;

        // Find the mainRole by its field (pral)
        let mainRole = data.find( element => {
          return element.pral
        });

        // Remove the main Role from the others
        let otherRoles = data.filter( element => {
          return element != mainRole
        });

        this.$set(this.newItem, 'mainRole', mainRole.idRol);
        this.$set(this.newItem, 'roles', otherRoles);
      });
    },
    openEditModal(item) {
      this.newItem = { ...item };
      this.isModalOpen = true;

      this.fetchUserRoles(this.newItem.idUser);
    },
    addOrEditItem(editUrl) {
      this.$axios.post(editUrl, this.newItem).then(() => {
        // Actualizar foto
        this.uploadPhoto();

        this.openAlert('success', "Registro actualizado con éxito", null);
        this.fetchData(`api/Users/GetUsers`);
        this.isModalOpen = false;
      });
    },
    handleFileChange() {
      // Whenever the file changes, populate the event with the file data.
      this.file = this.$refs.file.files[0];
    },
    uploadPhoto() {
      // ASIGNAMOS LAS PROPIEDADES AL OBJECTO FORMDATA.
      let formData = new FormData();
      formData.append("file", this.file);
      formData.append("idUser", this.newItem.idUser);

      this.$axios.post("api/Users/SubirFoto", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
    },
    selectMainRole(idRol) {
      this.$axios.post(`api/Users/Multirol`, {
        idUser: this.newItem.idUser,
        idRol: parseInt(idRol),
        pral: true
      });
    },
    storeRole(item) {
      this.$axios.post(`api/Users/Multirol`, {
        idUser: this.newItem.idUser,
        idRol: item.idRol,
        pral: false
      }).then(() => {
        this.fetchUserRoles();
      });
    },
    removeRole(item) {
      this.$axios.post(`api/Users/Deleterol`, item);
    }
  }
};
</script>